import { Button, styled, IconButton, Menu, MenuItem, ListItemText } from '@mui/material'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { useState, memo } from 'react'

const StyledButton = styled(Button)(() => ({
  border: '1px solid #CBD2DB',
  borderRight: 0,
  minWidth: 0,
  color: '#465464',
  padding: '5px 15px',
}))

function ButtonsWithPagination({ pageTotal, onPageChange }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const pageLast = pageTotal
  const maxBeginning = Math.min(pageTotal - 1, 3)
  const pageBeginnings = new Array(maxBeginning).fill(null).map((v, idx) => idx + 1)

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleCloseMenu = () => {
    setAnchorEl(null)
  }
  const handleMenuItemClick = (event, page) => {
    onPageChange(event, page)
    handleCloseMenu()
  }

  const renderMenuItems = () => {
    const items = []
    for (let i = maxBeginning + 1; i < pageLast; i++) {
      items.push(
        <MenuItem key={i} onClick={(e) => handleMenuItemClick(e, i - 1)}>
          <ListItemText primary={i} />
        </MenuItem>
      )
    }
    return items
  }
  if (pageTotal < 3) return null

  return (
    <>
      {pageBeginnings.map((p, idx) => (
        <StyledButton key={p * idx} onClick={(e) => onPageChange(e, +p - 1)}>
          {p}
        </StyledButton>
      ))}
      {maxBeginning === 3 && (
        <IconButton
          sx={{ borderRadius: 0, padding: '5px 10px', border: '1px solid #CBD2DB' }}
          onClick={handleOpenMenu}
          aria-label="menu"
        >
          <MoreHorizIcon />
        </IconButton>
      )}
      <StyledButton onClick={(e) => onPageChange(e, pageLast - 1)}>{pageLast}</StyledButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
        {renderMenuItems()}
      </Menu>
    </>
  )
}

export default ButtonsWithPagination

export const MemoizedButtons = memo(ButtonsWithPagination)
